export default __webpack_public_path__ + "static/media/checkmark.a767d070.svg";